import axios from 'axios';
import { backendUrl } from '../backendUrl';

// Create a dedicated axios instance for admin API calls
const adminApi = axios.create({
  baseURL: `${backendUrl}/api/v1/configurator/admin`,
});

// Attach JWT token to every request
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401/403 responses (expired or invalid token)
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminPermissions');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export async function adminLogin(username: string, password: string): Promise<boolean> {
  try {
    const response = await axios.post(`${backendUrl}/api/login`, { username, password });
    const { token, permissions } = response.data;
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminPermissions', JSON.stringify(permissions || []));
    return true;
  } catch {
    return false;
  }
}

export function getAdminPermissions(): string[] {
  try {
    const perms = localStorage.getItem('adminPermissions');
    return perms ? JSON.parse(perms) : [];
  } catch (e) {
    return [];
  }
}

export function adminLogout(): void {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminPermissions');
}

export function isAdminLoggedIn(): boolean {
  return !!localStorage.getItem('adminToken');
}

export default adminApi;
